import { ICtaBO } from '@effy-tech/acquisition-core/shared';
import {
  IFieldMediaImage,
  IFieldMediaImageWithOnlyWebp,
  IFieldMediaImageWithWebp,
  IFieldMediaImageWithWebpBo,
} from '../../interfaces/field-media-image';
import { ILink } from '../../interfaces/link';
import { IRteText } from '../../interfaces/rte-text';

export const TypeNameBlockCardsProduct = 'ParagraphBlocCardsProduct';

interface IProductBO {
  entity: {
    __typename: 'NodeProduct';
    nid: number; // product's id
    title: string; // product's name
    typology: {
      entity: {
        __typename: 'TaxonomyTermProductTypology';
        tid: number;
        name: string;
      };
    };
    description: IRteText;
    logo: {
      entity: {
        fieldMediaImage: IFieldMediaImageWithOnlyWebp;
      };
    };
    image: IFieldMediaImageWithWebpBo;
    price: string;
    CTAUrl: ICtaBO;
  };
}

export interface IBlockCardsProductBO {
  __typename: typeof TypeNameBlockCardsProduct;
  title: string;
  chapo: string;
  products: IProductBO[];
}

export interface IBlockCardsProduct {
  __typename: typeof TypeNameBlockCardsProduct;
  title: string;
  chapo: string;
  products: {
    id: string;
    name: string;
    description: string;
    logo: IFieldMediaImage;
    image: IFieldMediaImageWithWebp;
    price: number;
    ctaUrl: ILink;
  }[];
}

export type IBlockCardProducts = IBlockCardsProduct['products'];
